import config from 'config';

import { deriveProductCategory } from '~/shared/utils/deriveProductCategory';
import { Gender } from '~/techstyle-shared/react-accounts';
import { useProductDetailContext } from '~/techstyle-shared/react-components';

const isGendered = config.get('public.brand.isGendered');

export default function useGuessLoggedOutCustomerGenderFromProduct() {
  const { isBundle, bundleProducts, product } = useProductDetailContext();

  if (!isGendered) {
    return Gender.FEMALE;
  }

  let isMale;
  if (isBundle) {
    const { isMens } = deriveProductCategory(bundleProducts[0]);
    isMale = isMens;
  } else {
    const { isMens } = deriveProductCategory(product);
    isMale = isMens;
  }

  if (isMale) {
    return Gender.MALE;
  }

  return Gender.FEMALE;
}
